module.exports = __webpack_public_path__ + "assets/img/2.6d87845d.svg";